export default {
  affectedApplicationData: ({ affectedApplicationData }) => affectedApplicationData || null,

}
